import { isStringNullOrWhiteSpace } from 'owa-localize';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getFileProviderAccessToken } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

async function isTokenAvailableForProvider(
    fileProviderType: AttachmentDataProviderType,
    url: string
): Promise<boolean> {
    const eventName = 'FPAccessTokenUnavailable';
    const customData = [fileProviderType];
    try {
        const token = await getFileProviderAccessToken(
            fileProviderType,
            false /* forceTokenRefresh */,
            url
        );
        if (isStringNullOrWhiteSpace(token)) {
            logUsage(eventName, customData);
            return false;
        }
        return true;
    } catch (error) {
        // If there is an error in getting the token then we consider that
        // the token is not available and hence return false
        logUsage(eventName, customData);
        return false;
    }
}

export default async function canCallFileProviderAPIFromClient(
    fileProviderType: AttachmentDataProviderType,
    url: string
): Promise<boolean> {
    switch (fileProviderType) {
        case AttachmentDataProviderType.Box:
        case AttachmentDataProviderType.Dropbox:
        case AttachmentDataProviderType.Facebook:
            return (
                isFeatureEnabled('doc-filePicker-thirdPartyProviderClientCalls') &&
                (await isTokenAvailableForProvider(fileProviderType, null))
            );
        case AttachmentDataProviderType.GDrive:
        // In case of GDrive we always have to make the call from client side
        // as there is no server side implementation of it
        case AttachmentDataProviderType.MailMessage:
            // No server side implementation of mail message file provider
            return true;
        case AttachmentDataProviderType.OneDrivePro:
            return await isTokenAvailableForProvider(fileProviderType, url);
        default:
            return false;
    }
}
